import "core-js/modules/es.string.trim.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, IconSet } from '..';
var propTypes = {
  label: PropTypes.string,
  /**
   * used by screen readers to describe the button
   */
  ariaLabel: PropTypes.string,
  /**
   specifies the identifier of a UI component associated with the help button.
  */
  toggleId: PropTypes.string.isRequired,
  /**
   additional style class(es) for this button
  */
  className: PropTypes.string,
  /**
   specifies the identifier of an element that describes the help button 
   and is used by screen readers to provide more information hat the user might need
  */
  ariaDescribedById: PropTypes.string,
  /** used by screen readers to determine expanded state */
  expanded: PropTypes.bool,
  /**
   A function that will be executed when toggling the help button.
  */
  onClick: PropTypes.func
};
var defaultProps = {
  className: undefined,
  label: 'Help',
  ariaLabel: 'Help',
  ariaDescribedById: undefined,
  expanded: false,
  onClick: function onClick() {}
};

/**
 * A help button that is intended to be used with an associated control.
 * Typically this control would be an alert which would be displayed when the help button is toggled.
 */
var HelpButton = function HelpButton(_ref) {
  var label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    className = _ref.className,
    ariaDescribedById = _ref.ariaDescribedById,
    toggleId = _ref.toggleId,
    expanded = _ref.expanded,
    onClick = _ref.onClick;
  var styleClass = classnames('wds-c-field-label-group__help-button', className, 'wds-c-button--icon wds-c-button--primary wds-u-ml--x-small');
  var showHelpText = label && label.trim() !== '';
  return /*#__PURE__*/React.createElement(Button, {
    className: styleClass,
    "aria-label": ariaLabel,
    "aria-controls": toggleId,
    "aria-expanded": expanded,
    "aria-describedby": ariaDescribedById,
    size: "small",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IconSet, {
    decorative: true,
    directional: true,
    name: "help",
    size: "medium"
  }), showHelpText && /*#__PURE__*/React.createElement("span", {
    className: "wds-u-pl--x-small"
  }, label));
};
HelpButton.propTypes = propTypes;
HelpButton.defaultProps = defaultProps;
HelpButton.displayName = 'HelpButton';
export default HelpButton;